import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
const CHECKOUT = 'https://fisio-pro.impultienda.ar/checkout';
export function CTAButton({
  children,
  href = CHECKOUT,
  className = ''
}: CTAButtonProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`block w-full rounded-md border-b-4 border-[#09535B] bg-brand-teal px-3 py-3 text-center font-button text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_5px_14px_rgba(14,106,115,.28)] transition hover:scale-[1.015] hover:bg-brand-ink active:translate-y-1 active:border-b-0 sm:text-base ${className}`} data-id="element-33" data-mp="2kzzfsp3ml8s9">{children}</a>;
}